export const ServicesID = 'service_9rvy8bs'
export const ContactTemplateID = 'template_jfcn9tv'
export const VolunteerTemplateID = 'template_volunteer'

export const UserID = 'oQoB9en3OAqcetsCs'
